import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

export const filterContainerStyle = {
  width: { base: '100%', lg: '75%' },
  mb: { base: '1.25rem', lg: '2rem' },
  p: { base: '1.25rem', lg: 0 },
  flexDirection: { base: 'column', lg: 'row' },
  bg: { base: COLOURS.gray[200], lg: COLOURS.white },
};

export const tabPanelsStyle = {
  my: { base: 5, lg: 0 },
  border: { base: 0, md: 'unset' },
  p: { base: 0, md: 'unset' },
  minH: { base: undefined, md: 400 },
  color: { base: COLOURS.black },
  overflow: { base: 'scroll', lg: 'auto' },
};

export const tabPanelStyle = {
  border: { base: 'none', lg: `1px solid ${COLOURS.gray[400]}` },
  px: { base: 0, lg: 5 },
  py: { base: 0, lg: 4 },
};
